// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".f-render-right-link{color:#666;font-size:14px;margin-left:24px;padding-left:10px;margin-bottom:10px;border-left:3px solid #eee}.f-render-right-search{padding:20px;box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
